import { __awaiter, __generator, __values } from "tslib";
import { Injectable } from '@angular/core';
import { GroupEntity, RightState } from './definitions.service';
import * as i0 from "@angular/core";
import * as i1 from "./data-model.service";
import * as i2 from "./log.service";
//Erklaerung: Ein user hat eine sub-collection mit rechten (ids kommen aus dem RightEntity enum). Der typ ist: Right (definitions). 
//Ein user gehoert ein- oder mehreren Gruppen an, die wiederrum auch Rechte haben. Die Gruppen-Ids werden dem user in der property: userGroups gegeben.
//Vergabe von Gruppenzugehoerigkeiten: zu definierten Zeitpunkten im Jahr. Z.b. nach der Forma Saison. automatisierter reminder
var UserRightsManagementService = /** @class */ (function () {
    function UserRightsManagementService(dataModel, log) {
        this.dataModel = dataModel;
        this.log = log;
        this._currentUserRights = undefined; //Klasse um einfachder damit umzgehen. Eine Liste mit Rechten und die dazugehoerige Gruppe.
        this._currentUsersGroups = undefined; //Groups sind als collection in Firestore vorhanden
        this._userId = undefined;
    }
    //Initially loads all data for the current user
    UserRightsManagementService.prototype.init = function (userId) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        this._userId = userId;
                        _a = this;
                        return [4 /*yield*/, this.retrieveUserRights(userId, true, false, true)];
                    case 1:
                        _a._currentUserRights = (_c.sent()).data;
                        _b = this;
                        return [4 /*yield*/, this.retrieveUserGroups(userId, true, false, true)];
                    case 2:
                        _b._currentUsersGroups = (_c.sent()).data;
                        return [2 /*return*/];
                }
            });
        });
    };
    UserRightsManagementService.prototype.isPartOfGroup = function (groupEntity) {
        if (this._userId) {
            return this.testing_isPartOfGroup(groupEntity);
        }
        return false;
    };
    UserRightsManagementService.prototype.isPartOfAdminGroup = function () {
        if (this._userId) {
            return this.testing_isPartOfGroup(GroupEntity.ADMIN.valueOf());
        }
        return false;
    };
    UserRightsManagementService.prototype.hasRight = function (right) {
        if (this._userId) {
            return this.testing_hasRight(right);
        }
        return false;
    };
    /**
   * Checks if this user is part of all groups that are assigned.
   */
    UserRightsManagementService.prototype.isPartOfGroups = function (groupEntities) {
        var _this = this;
        if (groupEntities == undefined) {
            return false;
        }
        groupEntities.forEach(function (entity) {
            if (!_this.testing_isPartOfGroup(entity)) {
                return false;
            }
        });
        return true;
    };
    /**
   * Checks if this user has all the rights that are assigned.
   */
    UserRightsManagementService.prototype.hasAllRights = function (rightEntities) {
        var _this = this;
        if (rightEntities == undefined) {
            return false;
        }
        rightEntities.forEach(function (entity) {
            if (!_this.testing_hasRight(entity)) {
                return false;
            }
        });
        return true;
    };
    //--------------------------------------------------------------------------
    /**
     * Checks if the assigned user has a given right.
     *
     * @param userId - the users id
     * @param right - the right to check
     * @returns a promise for a boolan. Returns true if user has right, false if not.
     */
    UserRightsManagementService.prototype.testing_hasRight = function (right) {
        var _a;
        return ((_a = this._currentUserRights) === null || _a === void 0 ? void 0 : _a.find(function (x) { return x.right.id == right.valueOf() && x.right.state == RightState.ALLOW.valueOf(); })) != undefined;
    };
    //Check if user is part of a group. E.g. if part of the admi group.
    UserRightsManagementService.prototype.testing_isPartOfGroup = function (group) {
        var _a;
        return ((_a = this._currentUsersGroups) === null || _a === void 0 ? void 0 : _a.find(function (x) { return x.id == group; })) != undefined;
    };
    /**
     * Gets a specific right. It returns the right and its state by the given identifier.
     *
     * @param userId - the users id
     * @param right - the right to check
     * @returns the right and group combination (if available), undefined if not.
     */
    UserRightsManagementService.prototype.getRight = function (right) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                return [2 /*return*/, (_a = this._currentUserRights) === null || _a === void 0 ? void 0 : _a.find(function (x) { return x.right.id == right.valueOf(); })];
            });
        });
    };
    /**
     * Checks if the state of the right is on 'allowed'.
     *
     * @param userId - the users id
     * @param right - the right to check
     * @returns a promise for a boolan. Returns true if user has right, false if not.
     */
    UserRightsManagementService.prototype.testing_allowed = function (right) {
        return __awaiter(this, void 0, void 0, function () {
            var hasRight;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.testing_hasRight(right)];
                    case 1:
                        hasRight = _a.sent();
                        if (!hasRight) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.getRight(right)];
                    case 2: return [2 /*return*/, (_a.sent()).right.state == RightState.ALLOW];
                    case 3: return [2 /*return*/, false];
                }
            });
        });
    };
    /**
     * Retrieve rights of a user. Includes also inherited rights.
     *
     * @param userId - user id
     * @returns the promise of a MethodReturn class instance
     */
    UserRightsManagementService.prototype.retrieveUserRights = function (userId, save, useCacheIfAvailable, forceReload) {
        if (save === void 0) { save = true; }
        if (useCacheIfAvailable === void 0) { useCacheIfAvailable = false; }
        if (forceReload === void 0) { forceReload = false; }
        return __awaiter(this, void 0, void 0, function () {
            var ret, foundIssues, loaded;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        ret = { result: false };
                        foundIssues = [];
                        return [4 /*yield*/, this.testing_getEffectiveUserRights(userId, foundIssues, useCacheIfAvailable, forceReload)];
                    case 1:
                        loaded = _a.sent();
                        if (loaded.result) {
                            this.log.log("Successfully loaded user rights");
                            if (save)
                                this._currentUserRights = loaded.data;
                            ret.result = true;
                            ret.data = loaded.data;
                            return [2 /*return*/, ret];
                        }
                        else {
                            this.log.error(loaded.errorMessage);
                        }
                        return [2 /*return*/, ret];
                }
            });
        });
    };
    /**
   * Retrieve groups of a user
   *
   * @param userId - user id
   * @returns the promise of a MethodReturn class instance
   */
    UserRightsManagementService.prototype.retrieveUserGroups = function (userId, save, useCacheIfAvailable, forceReload) {
        if (save === void 0) { save = true; }
        if (useCacheIfAvailable === void 0) { useCacheIfAvailable = false; }
        if (forceReload === void 0) { forceReload = false; }
        return __awaiter(this, void 0, void 0, function () {
            var ret, foundIssues, loaded;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        ret = { result: false };
                        foundIssues = [];
                        return [4 /*yield*/, this.testing_getUserGroups(userId, foundIssues, useCacheIfAvailable, forceReload)];
                    case 1:
                        loaded = _a.sent();
                        if (loaded.result) {
                            this.log.log("Successfully loaded user groups");
                            if (save)
                                this._currentUsersGroups = loaded.data;
                            ret.result = true;
                            ret.data = loaded.data;
                            return [2 /*return*/, ret];
                        }
                        else {
                            this.log.error(loaded.errorMessage);
                        }
                        return [2 /*return*/, ret];
                }
            });
        });
    };
    /**
     * Get all effective rights of a user. It depends on the personal rights and all inherited rights from all assigned groups.
     *
     * @param userId - the users id
     * @param outFoundIssues - list of found issues while gathering rights
     * @returns the promise of a MethodReturn class instance
     */
    UserRightsManagementService.prototype.testing_getEffectiveUserRights = function (userId, outFoundIssues, useCacheIfAvailable, forceReload) {
        if (outFoundIssues === void 0) { outFoundIssues = []; }
        if (useCacheIfAvailable === void 0) { useCacheIfAvailable = false; }
        if (forceReload === void 0) { forceReload = false; }
        return __awaiter(this, void 0, void 0, function () {
            var ret, userBelongsToGroups, cacheAvailable, loadedUser, effectiveRights, userData, allGroups, userSpecificRights, usersGroupsIds, loadedGroupData, msg, loadedUserRights, msg, userBelongsToGroups_1, userBelongsToGroups_1_1, group, loadedGroupRights, msg, _a, _b, right, found, foundData, existing, existingGroup, existingRight, existingLevel, toCheckGroup, toCheckRight, toCheckLevel, msg, e_1_1;
            var e_1, _c, e_2, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        ret = { result: false };
                        if (userId == undefined || userId == "") {
                            ret.errorMessage = "Undefined user id";
                            return [2 /*return*/, ret];
                        }
                        userBelongsToGroups = [];
                        if (useCacheIfAvailable) {
                            cacheAvailable = this._currentUserRights != undefined;
                            if (cacheAvailable) {
                                if (!forceReload) {
                                    ret.result = true;
                                    ret.data = this._currentUserRights;
                                    return [2 /*return*/, ret];
                                }
                            }
                        }
                        return [4 /*yield*/, this.dataModel.getUser(userId, true)];
                    case 1:
                        loadedUser = _e.sent();
                        if (!loadedUser.result)
                            return [2 /*return*/, loadedUser];
                        effectiveRights = [];
                        userData = loadedUser.data;
                        allGroups = [];
                        userSpecificRights = [];
                        usersGroupsIds = userData.userGroups;
                        if (!(usersGroupsIds.length > 0)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.dataModel.getGroups(false, true)];
                    case 2:
                        loadedGroupData = _e.sent();
                        if (!loadedGroupData.result) {
                            this.log.error("Unable to retrieve all groups data");
                            msg = "Unable to retrieve all groups data";
                            outFoundIssues.push(msg);
                            ret.errorMessage = msg;
                            return [2 /*return*/, ret];
                        }
                        else
                            allGroups = loadedGroupData.data;
                        _e.label = 3;
                    case 3: return [4 /*yield*/, this.dataModel.getUserSpecificRights(userId, true)];
                    case 4:
                        loadedUserRights = _e.sent();
                        if (!loadedUserRights.result) {
                            msg = "Unable to retrieve user rights for user with id: " + userId;
                            outFoundIssues.push(msg);
                            ret.errorMessage = msg;
                            return [2 /*return*/, ret];
                        }
                        else
                            userSpecificRights = loadedUserRights.data;
                        //get all groups the user belongs to 
                        userBelongsToGroups = allGroups.filter(function (x) { return usersGroupsIds.includes(x.id); });
                        this.gatherAllGroups(userBelongsToGroups, allGroups);
                        //sort (lowest levels first)
                        userBelongsToGroups = userBelongsToGroups.sort(function (a, b) { return a.id < b.id ? 1 : a.id > b.id ? -1 : 0; });
                        _e.label = 5;
                    case 5:
                        _e.trys.push([5, 10, 11, 12]);
                        userBelongsToGroups_1 = __values(userBelongsToGroups), userBelongsToGroups_1_1 = userBelongsToGroups_1.next();
                        _e.label = 6;
                    case 6:
                        if (!!userBelongsToGroups_1_1.done) return [3 /*break*/, 9];
                        group = userBelongsToGroups_1_1.value;
                        return [4 /*yield*/, this.dataModel.getGroupRights(group.id, true)];
                    case 7:
                        loadedGroupRights = _e.sent();
                        if (!loadedGroupRights.result) {
                            msg = "Unable to retrieve user rights for user with id: " + userId;
                            outFoundIssues.push(msg);
                            ret.errorMessage = msg;
                        }
                        else {
                            group.rights = loadedGroupRights.data;
                            try {
                                //iterate over group rights
                                for (_a = (e_2 = void 0, __values(group.rights)), _b = _a.next(); !_b.done; _b = _a.next()) {
                                    right = _b.value;
                                    found = this.getEffectiveRightHelper(right, group, allGroups);
                                    if (found.result) {
                                        foundData = found.data;
                                        existing = effectiveRights.find(function (x) {
                                            return x.right.id == foundData.right.id;
                                        });
                                        if (existing != undefined) {
                                            existingGroup = existing.group;
                                            existingRight = existing.right;
                                            existingLevel = existing.group.parent_id;
                                            toCheckGroup = foundData.group;
                                            toCheckRight = foundData.right;
                                            toCheckLevel = foundData.group.parent_id;
                                            //same level?
                                            if (existingLevel == toCheckLevel) {
                                                //same state? only a conflict if different states
                                                if (existingRight.state == toCheckRight.state) {
                                                    msg = "Duplicate right found with different values found: (right id: " + existingRight.id + " | state: " + existingRight.state + " | group id: " + existingGroup.id + ") vs. (right id: " + toCheckRight.id + " | state: " + toCheckRight.state + " | group id: " + toCheckGroup.id + ")";
                                                    this.log.error(msg);
                                                    outFoundIssues.push(msg);
                                                }
                                            }
                                        }
                                        else
                                            effectiveRights.push(found.data); //right not existing in results -> add          
                                    }
                                }
                            }
                            catch (e_2_1) { e_2 = { error: e_2_1 }; }
                            finally {
                                try {
                                    if (_b && !_b.done && (_d = _a.return)) _d.call(_a);
                                }
                                finally { if (e_2) throw e_2.error; }
                            }
                            ;
                        }
                        _e.label = 8;
                    case 8:
                        userBelongsToGroups_1_1 = userBelongsToGroups_1.next();
                        return [3 /*break*/, 6];
                    case 9: return [3 /*break*/, 12];
                    case 10:
                        e_1_1 = _e.sent();
                        e_1 = { error: e_1_1 };
                        return [3 /*break*/, 12];
                    case 11:
                        try {
                            if (userBelongsToGroups_1_1 && !userBelongsToGroups_1_1.done && (_c = userBelongsToGroups_1.return)) _c.call(userBelongsToGroups_1);
                        }
                        finally { if (e_1) throw e_1.error; }
                        return [7 /*endfinally*/];
                    case 12:
                        ;
                        //now lets check the user specific rights. If there is one defined, it will override any from group. Otherwise, the right is take right away.
                        userSpecificRights.forEach(function (r) {
                            var ixExisting = effectiveRights.findIndex(function (x) { return x.right.id == r.id; });
                            if (ixExisting >= 0) {
                                var toInsert = { right: r, group: undefined };
                                effectiveRights[ixExisting] = toInsert;
                            }
                            else {
                                var toInsert = { right: r, group: undefined };
                                effectiveRights.push(toInsert);
                            }
                        });
                        ret.result = true;
                        ret.data = effectiveRights;
                        return [2 /*return*/, ret];
                }
            });
        });
    };
    /**
   * Get all groups a user is assigned to. Includes also the inherited.
   *
   * @param userId - the users id
   * @param outFoundIssues - list of found issues while gathering groups
   * @returns the promise of a MethodReturn class instance
   */
    UserRightsManagementService.prototype.testing_getUserGroups = function (userId, outFoundIssues, useCacheIfAvailable, forceReload) {
        if (outFoundIssues === void 0) { outFoundIssues = []; }
        if (useCacheIfAvailable === void 0) { useCacheIfAvailable = false; }
        if (forceReload === void 0) { forceReload = false; }
        return __awaiter(this, void 0, void 0, function () {
            var ret, cacheAvailable, loadedUser, userData, allGroups, usersGroupsIds, loadedGroupData, msg, userBelongsToGroups;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        ret = { result: false };
                        if (userId == undefined || userId == "") {
                            ret.errorMessage = "Undefined user id";
                            return [2 /*return*/, ret];
                        }
                        if (useCacheIfAvailable) {
                            cacheAvailable = this._currentUsersGroups != undefined;
                            if (cacheAvailable) {
                                if (!forceReload) {
                                    ret.result = true;
                                    ret.data = this._currentUsersGroups;
                                    return [2 /*return*/, ret];
                                }
                            }
                        }
                        return [4 /*yield*/, this.dataModel.getUser(userId, true)];
                    case 1:
                        loadedUser = _a.sent();
                        if (!loadedUser.result)
                            return [2 /*return*/, loadedUser];
                        userData = loadedUser.data;
                        allGroups = [];
                        usersGroupsIds = userData.userGroups;
                        if (!(usersGroupsIds.length > 0)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.dataModel.getGroups(false, true)];
                    case 2:
                        loadedGroupData = _a.sent();
                        if (!loadedGroupData.result) {
                            this.log.error("Unable to retrieve all groups data");
                            msg = "Unable to retrieve all groups data";
                            outFoundIssues.push(msg);
                            ret.errorMessage = msg;
                            return [2 /*return*/, ret];
                        }
                        else
                            allGroups = loadedGroupData.data;
                        _a.label = 3;
                    case 3:
                        userBelongsToGroups = allGroups.filter(function (x) { return usersGroupsIds.includes(x.id); });
                        this.gatherAllGroups(userBelongsToGroups, allGroups);
                        //sort (lowest levels first)
                        userBelongsToGroups = userBelongsToGroups.sort(function (a, b) { return a.id < b.id ? 1 : a.id > b.id ? -1 : 0; });
                        ret.result = true;
                        ret.data = userBelongsToGroups;
                        return [2 /*return*/, ret];
                }
            });
        });
    };
    /**
     * Iterates through the group levels to get the effective rights.
     *
     * @param right - the right to check
     * @param group - the group to check
     * @param allGroups - a list of all available groups
     * @returns a MethodReturn
     */
    UserRightsManagementService.prototype.getEffectiveRightHelper = function (right, group, allGroups) {
        var _this = this;
        var ret = { result: false };
        var retData;
        if (group == undefined) {
            ret.errorMessage = "Group not found";
            return ret;
        }
        var upperGroup = allGroups.find(function (x) { return x.id == group.parent_id; });
        var foundInThisGroup = false;
        //iterate over group rights
        group.rights.forEach(function (x) {
            if (x.id == right.id) {
                foundInThisGroup = true;
                if (x.state == RightState.ALLOW.valueOf() || x.state == RightState.DECLINE.valueOf()) {
                    var insert = { right: x, group: group };
                    retData = insert;
                    ret.result = true;
                    return ret;
                }
                else if (x.state == RightState.INHERIT) {
                    //check for right in higher leveled group
                    ret = _this.getEffectiveRightHelper(right, upperGroup, allGroups);
                    if (ret.result)
                        retData = ret.data;
                    return ret;
                }
                else {
                    // right is undefined
                    _this.log.error("Right: id: " + right.id + ", name: " + right.name + " is undefined.");
                    ret.errorMessage = "Right not found in group: (id: " + group.id + ", name: " + group.name + ").";
                    return ret;
                }
            }
        });
        if (!foundInThisGroup) {
            //right was not found in this group. But it's possible that the right is defined a level up
            //check for right in higher leveled group
            ret = this.getEffectiveRightHelper(right, upperGroup, allGroups);
            if (ret.result)
                retData = ret.data;
        }
        ret.data = retData;
        return ret;
    };
    /**
     * Gathers all groups by parsing through the tree to the top.
     *
     * @param intialList - the list of groups that are assigned to a user.
     * @param allGroups - a list of all available groups.
     * @returns a list of found groups
     */
    UserRightsManagementService.prototype.gatherAllGroups = function (intialList, allGroups) {
        var _this = this;
        var ret = intialList;
        intialList.forEach(function (element) {
            var found = _this.gatherAllGroupsHelper(element, allGroups);
            found.forEach(function (item) {
                var alreadyExisting = ret.find(function (x) { return x.id == item.id; });
                if (alreadyExisting == undefined)
                    ret.push(item);
            });
        });
        return ret;
    };
    /**
     * Helper to interate through the groups tree.
     *
     * @param current - the current group to check
     * @param allGroups - a list of all available groups
     * @returns a list of found groups
     */
    UserRightsManagementService.prototype.gatherAllGroupsHelper = function (current, allGroups) {
        var ret = [];
        //check if parent is available
        var foundParent = allGroups.find(function (x) { return x.id == current.parent_id; });
        if (foundParent == undefined) {
            //parent not found -> end
            return ret;
        }
        else {
            ret.push(foundParent);
            var nextItems = this.gatherAllGroupsHelper(foundParent, allGroups);
            //add found
            nextItems.forEach(function (element) {
                ret.push(element);
            });
        }
        return ret;
    };
    //------------------------Testing ------------------------
    UserRightsManagementService.prototype.setTestGroups = function (groups) {
        this.dataModel.setTestGroups(groups);
    };
    UserRightsManagementService.prototype.setTestUsers = function (users) {
        this.dataModel.setTestUsers(users);
    };
    UserRightsManagementService.ɵfac = function UserRightsManagementService_Factory(t) { return new (t || UserRightsManagementService)(i0.ɵɵinject(i1.DataModelService), i0.ɵɵinject(i2.LogService)); };
    UserRightsManagementService.ɵprov = i0.ɵɵdefineInjectable({ token: UserRightsManagementService, factory: UserRightsManagementService.ɵfac, providedIn: 'root' });
    return UserRightsManagementService;
}());
export { UserRightsManagementService };
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UserRightsManagementService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.DataModelService }, { type: i2.LogService }]; }, null); })();
//# sourceMappingURL=user-rights-management.service.js.map